import React from 'react';

interface BaseProps {
  label: string;
  hint?: string;
}

interface InputFieldProps extends BaseProps {
  type?: 'text' | 'number' | 'email' | 'tel' | 'date' | 'password';
  value: string | number;
  min?: number;
  max?: number;
  readOnly?: boolean;
  /** Browser autofill hint, e.g. `off`, `new-password`, `current-password`. */
  autoComplete?: string;
  name?: string;
  onChange: (next: string) => void;
}

export function InputField({ label, hint, type = 'text', value, min, max, readOnly, autoComplete, name, onChange }: InputFieldProps) {
  return (
    <div className="sf2">
      <label className="sf2-label">{label}</label>
      <input
        className={`sf2-input${readOnly ? ' readonly' : ''}`}
        type={type}
        value={value}
        min={min}
        max={max}
        readOnly={readOnly}
        autoComplete={autoComplete}
        name={name}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint && <div className="sf2-hint">{hint}</div>}
    </div>
  );
}

interface SelectFieldProps extends BaseProps {
  value: string | number;
  options: ReadonlyArray<{ value: string | number; label: string }>;
  onChange: (next: string) => void;
}

export function SelectField({ label, hint, value, options, onChange }: SelectFieldProps) {
  return (
    <div className="sf2">
      <label className="sf2-label">{label}</label>
      <select className="sf2-select" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {hint && <div className="sf2-hint">{hint}</div>}
    </div>
  );
}

interface TextAreaFieldProps extends BaseProps {
  value: string;
  rows?: number;
  onChange: (next: string) => void;
}

export function TextAreaField({ label, hint, value, rows = 3, onChange }: TextAreaFieldProps) {
  return (
    <div className="sf2">
      <label className="sf2-label">{label}</label>
      <textarea className="sf2-textarea" rows={rows} value={value} onChange={(e) => onChange(e.target.value)} />
      {hint && <div className="sf2-hint">{hint}</div>}
    </div>
  );
}
